import styled from "styled-components";
import moment from "moment-timezone";
import { AirportLegInfo } from "@/components/molecules";
import { Col, Popover, Row } from "antd";
import { RAImage, RATypography } from "@/components/customs";
import { lightTheme } from "@/themes/ThemeConfig";
import { SvgAirplaneSeat, SvgArrowStraightRight } from "@/assets/icons";
import { formatCurrency } from "@/utils";
import { RAEmptyLegLabel } from "@/components/atoms";
import { useSelector } from "react-redux";
import { selectFormatDateTimeDeparture } from "@/stores/slices/authSlice";
import { useState } from "react";

export function CardEmptyLegDetailMobile({ detail = {}, onShowDetails }) {
	const {
		aircraft = {},
		departure,
		departure_window,
		from_airport,
		label = "",
		to_airport,
		price_inc_tax,
		empty_leg,
	} = detail;
	const formatDTDeparture = useSelector(selectFormatDateTimeDeparture);

	const _renderDeparture = () => {
		if (!departure?.utc_datetime && label === "INVITED" && empty_leg?.departure?.utc_datetime) {
			return (
				<Row gutter={16}>
					<Col span={24}>
						<RATypography variant="body4" color="#595959">
							{empty_leg?.departure_window?.utc_datetime ? "Departure window" : "Departure time"}
						</RATypography>
					</Col>
					<Col span={24}>
						{empty_leg?.departure_window?.utc_datetime ? (
							<>
								<Row align="middle" justify="space-between">
									<Col>
										<RATypography variant="body4" color="#595959">
											From
										</RATypography>
									</Col>
									<Col>
										<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
											{empty_leg?.departure?.utc_datetime
												? moment(empty_leg?.departure?.utc_datetime)
														.tz(from_airport?.location?.timezone)
														.format("DD MMM YYYY")
												: "TBD"}
										</RATypography>
									</Col>
								</Row>
								<Row align="middle" justify="space-between">
									<Col>
										<RATypography variant="body4" color="#595959">
											To
										</RATypography>
									</Col>
									<Col>
										<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
											{empty_leg?.departure_window?.utc_datetime
												? moment(empty_leg?.departure_window?.utc_datetime)
														.tz(from_airport?.location?.timezone)
														.format("DD MMM YYYY")
												: "TBD"}
										</RATypography>
									</Col>
								</Row>
							</>
						) : (
							<RATypography variant="sub-heading4" color={lightTheme.color_text_500} top="4px">
								{`${moment(empty_leg?.departure?.utc_datetime)
									.tz(from_airport?.location?.timezone)
									.format("DD MMM YYYY")}`}
							</RATypography>
						)}

						<RATypography variant="label4" color={lightTheme.color_primary_500} top="4px" align="right">
							INQUIRE FOR DEPARTURE TIME
						</RATypography>
					</Col>
				</Row>
			);
		}

		if (departure_window) {
			return (
				<Row align="middle" gutter={16}>
					<Col md={12} xs={24}>
						<RATypography variant="body4" color="#595959">
							Departure window
						</RATypography>
					</Col>
					<Col md={12} xs={24}>
						<Row align="middle" justify="space-between">
							<Col>
								<RATypography variant="body4" color="#595959">
									From
								</RATypography>
							</Col>
							<Col>
								<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
									{departure?.utc_datetime
										? moment(departure?.utc_datetime)
												.tz(from_airport?.location?.timezone)
												.format(formatDTDeparture)
										: "TBD"}
								</RATypography>
							</Col>
						</Row>
						<Row align="middle" justify="space-between">
							<Col>
								<RATypography variant="body4" color="#595959">
									To
								</RATypography>
							</Col>
							<Col>
								<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
									{departure_window?.utc_datetime
										? moment(departure_window?.utc_datetime)
												.tz(from_airport?.location?.timezone)
												.format(formatDTDeparture)
										: "TBD"}
								</RATypography>
							</Col>
						</Row>
					</Col>
				</Row>
			);
		}

		return (
			<Row align="middle" justify="space-between" gutter={16}>
				<Col>
					<RATypography variant="body4" color="#595959">
						Departure time
					</RATypography>
				</Col>
				<Col>
					<RATypography variant="sub-heading4" color={lightTheme.color_text_500}>
						{departure?.utc_datetime
							? moment(departure?.utc_datetime)
									.tz(from_airport?.location?.timezone)
									.format(formatDTDeparture)
							: "TBD"}
					</RATypography>
				</Col>
			</Row>
		);
	};

	return (
		<ContainerCharter data-testid="emptyLegs_row">
			<Row
				style={{
					padding: "12px",
				}}
			>
				<Col
					span={24}
					style={{
						border: "1px dashed #e9e8e8",
						padding: "28px 12px 12px 12px",
						borderRadius: "10px",
					}}
				>
					<AirportLegInfo from_airport={from_airport} to_airport={to_airport} />
					<WrapperLabel>
						<RAEmptyLegLabel label={label} />
					</WrapperLabel>
				</Col>
			</Row>

			<Row style={{ padding: "16px 12px" }} gutter={[0, 12]}>
				<Col span={24}>
					<Row align="middle" gutter={16}>
						<Col span={12}>
							<RAImage
								url={
									aircraft?.images && aircraft?.images[0]
										? aircraft?.images[0].url
										: "/images/example/aircraft_1.png"
								}
								width="100%"
								height="72px"
								borderRadius="6px"
							/>
						</Col>
						<Col span={12}>
							<RATypography variant="sub-heading3" color="#222222">
								{aircraft?.name ?? "Unknown"}
							</RATypography>
						</Col>
					</Row>
				</Col>
				<Col span={24}>{_renderDeparture()}</Col>
				<Col span={24}>
					<Row align="middle" justify="space-between" gutter={16}>
						<Col>
							<RATypography variant="body4" color="#595959">
								Price
							</RATypography>
						</Col>
						<Col>
							<RATypography variant="label2" color="#222222">
								{!price_inc_tax ? "REQUEST PRICING" : formatCurrency(price_inc_tax, "USD", 0)}
							</RATypography>
						</Col>
					</Row>
				</Col>
				<Col span={24}>
					<WrapperAmenities>
						<Row>
							<SvgAirplaneSeat />
							<RATypography variant="sub-heading4" color="#65686F" left={12} right={12}>
								{`${aircraft?.max_pax ?? "_"} Pax`}
							</RATypography>
						</Row>
						<CardAmenities amenities={aircraft?.amenities} />
					</WrapperAmenities>
				</Col>
			</Row>
			<Row
				style={{
					borderTop: "1px solid #e9e8e8",
					cursor: "pointer",
					padding: 10,
				}}
				align="middle"
				justify="center"
				onClick={() => onShowDetails(detail)}
				data-testid="emptyLegs_detailsBtn"
			>
				<RATypography variant="button3" style={{ letterSpacing: "2px" }}>
					DETAILS
				</RATypography>
				<SvgArrowStraightRight />
			</Row>
		</ContainerCharter>
	);
}

const CardAmenities = ({ amenities = [] }) => {
	const [showAll, setShowAll] = useState(false);

	if (!amenities || amenities?.length === 0) return null;
	return amenities?.map((item, index) => {
		if (index < 5 || showAll) {
			return (
				<Popover
					key={index}
					placement="bottom"
					title=""
					content={() => {
						return (
							<RATypography variant="body4" color="#595959">
								{item?.name || ""}
							</RATypography>
						);
					}}
				>
					<AmenitiesItem>
						<RAImage url={item?.image?.url} width="20px" height="20px" />
					</AmenitiesItem>
				</Popover>
			);
		}
		if (index === 5 && !showAll) {
			return (
				<AmenitiesItem key={index}>
					<WrapperShowMore onClick={() => setShowAll(true)}>
						<RATypography variant="sub-heading4" color="#A8A8A8">
							{`+${amenities?.length - 5}`}
						</RATypography>
					</WrapperShowMore>
				</AmenitiesItem>
			);
		}
	});
};

const ContainerCharter = styled.div`
	width: "100%";
	gap: 30px;
	border: 1px solid #e9e8e8;
	border-radius: 12px;
`;
const AmenitiesItem = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 12px;
	border-left: 1px solid #e9e8e8;
`;
const WrapperLabel = styled.div`
	position: absolute;
	top: 1px;
	left: 1px;
`;
const WrapperShowMore = styled.div`
	border-radius: 40px;
	background: #f3f2f2;
	display: flex;
	padding: 3px 10px;
	align-items: center;
	gap: 8px;
	cursor: pointer;
`;
const WrapperAmenities = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
`;
